import React, { useContext, useState } from 'react'
import { AuthFetch } from '../../services/api'
import { notify, urlApiTMAN } from '../../utils/utils'
import { UserContext } from '../../context/provider/UserProvider'

export const useIngresoTraslado = () => {
    const {stateUser} = useContext(UserContext)
    const COD_EMPRESA = stateUser.codEmpresa
    const COD_USUARIO = stateUser.codUsuario

    const [listaIngresos,setListaIngresos] = useState([])
    const [ultimoDocumentoIngreso,setUltimoDocumentoIngreso] = useState({})

    const listarIngresoPorTraslado = async (fechaInicio,fechaFin) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Entry/warehouseTransfer?' + new URLSearchParams({
                CodEmpresa: COD_EMPRESA,
                CodUsuarioAccion: COD_USUARIO,
                FechaInicio: fechaInicio,
                FechaFin: fechaFin
            })
        })
        if(response.isValid){
            setListaIngresos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarInfoMovimiento = async (codTransferencia) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Entry/headerAndDetail?' + new URLSearchParams({
                CodEmpresa: COD_EMPRESA,
                CodTransferencia: codTransferencia
            })
        })

        return response.isValid ? response.content : []
    }

    const obtenerUltimoDocumentoIngreso = async () => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Entry/guide?' + new URLSearchParams({
                CodEmpresa: COD_EMPRESA,
                CodUsuarioAccion: COD_USUARIO
            })
        })

        if(response.isValid){
            setUltimoDocumentoIngreso(response.content[0])
        }else{
            setUltimoDocumentoIngreso({})
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarIngresoPorTrasladoAlmacen = async ({
        codTransferencia = 0,
        codAlmacenDestino = 0,
        comentarioDestino = '',
        codDocumento = 0,
        serieDocumento = '',
        correlativoDocumento = 0,
        transferenciaDetalle = []
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Entry',
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: COD_EMPRESA,
                codTransferencia: codTransferencia,
                codAlmacenDestino: codAlmacenDestino,
                codUsuarioDestino: COD_USUARIO,
                comentarioDestino: comentarioDestino,
                codDocumento: codDocumento,
                serieDocumento: serieDocumento,
                correlativoDocumento: correlativoDocumento,
                transferenciaDetalle: transferenciaDetalle
                // [
                //     {
                //     "codRepuesto": 0,
                //     "registraSerie": true,
                //     "cantidadRepuesto": 0,
                //     "listaSeries": [
                //         {
                //         "codSerieRepuesto": "string"
                //         }
                //     ]
                //     }
                // ]
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    
    
    return {
        listarIngresoPorTraslado,
        listaIngresos,

        listarInfoMovimiento,

        obtenerUltimoDocumentoIngreso,
        ultimoDocumentoIngreso,

        registrarIngresoPorTrasladoAlmacen
    }
}
